import Vue from "vue";
export default Vue.extend({
    props: {
        uniqueKey: {
            type: String,
            required: true,
        },
    },
});
